import * as R from 'ramda';

import moment from 'moment';
import {MAPS} from 'js/common';

const {PublisherToGender} = MAPS;

const immediateFailures = {
    gender({profile}, {answer_desired}) {
        const gender = profile.publisher_type && PublisherToGender[profile.publisher_type];
        return profile && gender
            ? answer_desired.value === PublisherToGender[profile.publisher_type]
            : null;
    },
    age({profile}, {answer_desired}) {
        if (!profile || !profile.birth_date) return null;
        const birthDate = moment().diff(profile.birth_date, 'years');
        // age falls is in the range of the desired answer
        return birthDate >= answer_desired[0] && birthDate <= answer_desired[1];
    }
};

const SmartQuestionHelper = {
    answerInferrableQuestions(user, smartQuestions) {
        if (R.isNil(smartQuestions) || R.isEmpty(smartQuestions) || R.isNil(user.profile)) {
            return null;
        }

        return R.reduce(
            (acc, item) => {
                const hasUnanswered = acc === null;
                if (acc === false) {
                    // return false if we infer that a user fails any questions
                    return acc;
                }

                if (R.has(item.id, immediateFailures)) {
                    // if a question is inferrable by user data
                    const inferredAnswer = immediateFailures[item.id](user, item);
                    if (inferredAnswer && hasUnanswered) {
                        // return null if the user hasn't failed any questions,
                        // but needs to answer at least one question
                        return null;
                    } else if (inferredAnswer) {
                        // return true if the user has passed all questions
                        return true;
                    } else if (inferredAnswer === false) {
                        // return false if the user has failed any questions
                        return false;
                    }
                    // return null if question needs to be answered
                    return null;
                }

                // return null if question is not inferable
                return null;
            },
            true,
            smartQuestions
        );
    }
};

export default SmartQuestionHelper;



// WEBPACK FOOTER //
// ./common/smart_question_helper.js